import { FilterList } from "@mui/icons-material";
import { DatePicker } from "@mui/lab";
import {
  Badge,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
  Autocomplete
} from "@mui/material";
import React, { useEffect, useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function InOutFilter({
  entryType,
  setEntryType,
  quantity,
  setQuantity,
  approved,
  setApproved,
  rejected,
  setRejected,
  createdBy,
  setCreatedBy,
  height,
  width,
  thickness,
  setHeight,
  setWidth,
  setThickness,
  apUsers,
  onFilter,
  createdDateFrom,
  setCreatedDateFrom,
  createdDateTo,
  setCreatedDateTo,
}) {
  const resetFilters = () => {
    setEntryType("");
    setCreatedBy("");
    setQuantity("");
    setApproved("");
    setRejected("");
    setCreatedDateFrom("");
    setCreatedDateTo("");
    setHeight("")
    setWidth("")
    setThickness("")
  };
  const [count, setCount] = useState(0);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    let totalCount = 0;
    if (entryType) {
      totalCount++;
    }
    if (quantity) {
      totalCount++;
    }
    if (approved) {
      totalCount++;
    }
    if (rejected) {
      totalCount++;
    }
    if (createdBy) {
      totalCount++;
    }
    if (createdDateFrom) {
      totalCount++
    }
    if (createdDateTo) {
      totalCount++
    }
    if (height) {
      totalCount++
    }
    if (width) {
      totalCount++
    }
    if (thickness) {
      totalCount++
    }
    setCount(totalCount);
    // eslint-disable-next-line
  }, [entryType, quantity, approved, rejected, createdBy, createdDateFrom, createdDateTo]);

  return (
    <Paper>
      <Tooltip title="Filters">
        <Badge badgeContent={count} color="error">
          <IconButton onClick={handleOpen} aria-label="Filters" size="small">
            <FilterList />
          </IconButton>
        </Badge>

        {/* <IconButton onClick={handleOpen} aria-label="Filters" size="large">
          <FilterList />
        </IconButton> */}
      </Tooltip>
      {apUsers && (
        <Modal open={open} onClose={handleClose}>
          <Card sx={style} style={{ width: "500px" }}>
            <CardContent>
              <Paper>
                <Grid container spacing={5}>
                  <Grid item xs={12} md={12} lg={12}>
                    <FormControl fullWidth>
                      <InputLabel id="label"> Type </InputLabel>
                      <Select
                        labelId="label"
                        fullWidth
                        id="label"
                        label="Select Type"
                        onChange={(e) => setEntryType(e.target.value)}
                        value={entryType}
                      >
                        <MenuItem disabled value={""}>
                          Select Type To
                        </MenuItem>

                        <MenuItem value={"inward"}>
                          <Typography color="#33B897">Inward</Typography>
                        </MenuItem>
                        <MenuItem value={"outward"}>
                          <Typography color="tomato">Outward</Typography>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12}>
                    <Autocomplete
                      options={apUsers}
                      getOptionLabel={(option) => option.name}
                      filterOptions={(options, { inputValue }) => {
                        if (!inputValue) return options;
                        const searchTerm = inputValue.toLowerCase();
                        return options.filter((option) =>
                          option.name.toLowerCase().includes(searchTerm)
                        );
                      }}
                      value={apUsers.find((u) => u._id === createdBy) || null}
                      onChange={(e, newValue) => setCreatedBy(newValue?._id || "")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Created By"
                          placeholder="Search users..."
                          variant="outlined"
                        />
                      )}
                      fullWidth
                      sx={{
                        "& .MuiAutocomplete-listbox": {
                          maxHeight: 200,
                        },
                      }}
                    />
                  </Grid>


                  <Grid item xs={12} md={12} lg={12}>
                    <FormControl fullWidth>
                      <InputLabel id="label"> Approved </InputLabel>
                      <Select
                        labelId="label"
                        fullWidth
                        id="label"
                        label="Select Approved to "
                        onChange={(e) => setApproved(e.target.value)}
                        value={approved}
                      >
                        <MenuItem disabled value={""}>
                          Select Approved To
                        </MenuItem>

                        <MenuItem value={"true"}>
                          <Typography>True</Typography>
                        </MenuItem>
                        <MenuItem value={"false"}>
                          <Typography>False</Typography>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12}>
                    <FormControl fullWidth>
                      <InputLabel id="label"> Rejected </InputLabel>
                      <Select
                        labelId="label"
                        fullWidth
                        id="label"
                        label="Select Rejected to "
                        onChange={(e) => setRejected(e.target.value)}
                        value={rejected}
                      >
                        <MenuItem disabled value={""}>
                          Select Rejected To
                        </MenuItem>

                        <MenuItem value={"true"}>
                          <Typography>True</Typography>
                        </MenuItem>
                        <MenuItem value={"false"}>
                          <Typography>False</Typography>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      type="number"
                      fullWidth
                      name="quantity"
                      value={quantity}
                      id="search-field"
                      label="Quantity"
                      onChange={(e) => setQuantity(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={6} md={6} lg={6}>
                    <FormControl fullWidth>
                      <DatePicker
                        name="created_date_from"
                        format="YYYY-MM-DD"
                        renderInput={(props) => <TextField {...props} />}
                        label="In Out Created  From"
                        value={createdDateFrom || null}
                        onChange={(newValue) => {
                          let selectedDate = newValue;
                          var month = (
                            "0" + parseInt(selectedDate?.getMonth() + 1)
                          ).slice(-2);
                          var day = (
                            "0" + parseInt(selectedDate?.getDate())
                          ).slice(-2);
                          let date =
                            selectedDate?.getFullYear() +
                            "-" +
                            month +
                            "-" +
                            day;
                          setCreatedDateFrom(date);
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} md={6} lg={6}>
                    <FormControl fullWidth>
                      <DatePicker
                        name="created_date_to"
                        format="YYYY-MM-DD"
                        renderInput={(props) => <TextField {...props} />}
                        label="In Out Created  To"
                        value={createdDateTo || null}
                        onChange={(newValue) => {
                          let selectedDate = newValue;
                          var month = (
                            "0" + parseInt(selectedDate?.getMonth() + 1)
                          ).slice(-2);
                          var day = (
                            "0" + parseInt(selectedDate?.getDate())
                          ).slice(-2);
                          let date =
                            selectedDate?.getFullYear() +
                            "-" +
                            month +
                            "-" +
                            day;
                          setCreatedDateTo(date);
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={4} lg={4}>
                    <TextField
                      label="Height"
                      fullWidth
                      value={height}
                      onChange={(e) => setHeight(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={4}>
                    <TextField
                      label="Width"
                      fullWidth
                      value={width}
                      onChange={(e) => setWidth(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={4}>
                    <TextField
                      label="Thickness"
                      fullWidth
                      value={thickness}
                      onChange={(e) => setThickness(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} md={6} lg={6}>
                    <Button onClick={resetFilters} color="error">
                      Reset All Filter
                    </Button>
                  </Grid>
                  <Grid
                    container
                    justifyContent={"flex-end"}
                    item
                    xs={12}
                    md={6}
                    lg={6}
                  >
                    <Button
                      onClick={() => {
                        handleClose();
                        onFilter();
                      }}
                      color="success"
                    >
                      OK
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </CardContent>
          </Card>
        </Modal>
      )}
    </Paper>
  );
}

export default InOutFilter;
